import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import { allData_excel, dashboardGraphData, get_wip_ep, get_wip_fins, get_wip_pipe, getOrderHistory } from "../../constant/url";
import { AccessContext } from "../../constant/accessContext";

import PendingSqPie from "../Component/graph/pendingSqPie";
import PendingGroupedSqPie from "../Component/graph/pendingGroupedSqPie";
import LastModuleWiseLine from "../Component/graph/lastModuleWiseLine";
import LastModuleOverAllLine from "../Component/graph/lastModuleOverAllLine";
import { toast } from "react-toastify";
import moment from "moment";
import AgeWeightBarChart from "./WIP/AgeWeightBarChart";
import AgeWeightDashboard from "./WIP/Adminpiechart";
import dayjs from "dayjs";

export default function Dashboard() {
	const access = React.useContext(AccessContext).authID;
	const [pendingSqPie, setPendingSqPie] = React.useState({
		label: [],
		data: [],
	});
	const [pendingGroupedSqPie, setPendingGroupedSqPie] = React.useState({
		label: [],
		data: [],
	});
	const [lastModuleWiseSQLine, setLastModuleWiseSQLine] = React.useState({
		label: [],
		data: [],
		allData: [],
	});
	const [lastModuleOverAllSQLine, setLastModuleOverAllSQLine] = React.useState({
		label: [],
		data: [],
	});

	const [summaryData, setSummaryData] = React.useState({
		live_order: 0,
		live_sq: 0,
		coil_qty: 0,
		completed_order: 0,
		pending_orders: 0,
		last_ready: "0000-00-00",
		completed_work: 0,
		pending_work: 0,
		completed_work_cent: 0,
		pending_work_cent: 0,
		pending_man_hours: 0,
	});

	const [compPendingSQCountGraph, setCompPendingSQCountGraph] =
		React.useState();

	const [compPendingGroupedSQCountGraph, setCompPendingGroupedSQCountGraph] =
		React.useState();
	const [compLastModuleLineSQCountGraph, setCompLastModuleLineSQCountGraph] =
		React.useState();

	const [
		compLastModuleOverAllLineSQCountGraph,
		setCompLastModuleOverAllLineSQCountGraph,
	] = React.useState();

	const rowTotal = (dataArray) => {

		// create an array
		const myNums = [
			parseInt(dataArray?.cnc_nest_compsq),
			parseInt(dataArray?.cnc_punch_compsq),
			parseInt(dataArray?.bending_compsq),
			parseInt(dataArray?.brazing_compsq),
			parseInt(dataArray?.ca_compsq),
			parseInt(dataArray?.ce_compsq),
			// parseInt(dataArray.dispatch_compsq),
			parseInt(dataArray?.finpunch_compsq),
			parseInt(dataArray?.pp_compsq),
			parseInt(dataArray?.tcutting_compsq),
		];

		// create a variable for the sum and initialize it
		let sum = 0;

		// calculate sum using forEach() method
		myNums.forEach((num) => {
			sum += num;
		});
		return sum;
	};

	const rowTotalAverage = (dataArray) => {
		return Math.round(rowTotal(dataArray) / 9);
	};

	const colTotal = (dataArray, colName) => {
		// create a variable for the sum and initialize it
		const noOfArray = 9;
		let sum = 0;
		let idx = 0;
		// calculate sum using forEach() method
		dataArray.forEach((row, index) => {
			if (idx < noOfArray) {
				idx = index + 1;
				sum = sum + parseInt(row[colName]);
			}
		});
		return Math.round(sum / idx);
	};

	const handlePendingSqCount = (authID) => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", authID);
		axios({
			method: "post",
			url: dashboardGraphData,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 101) {
					// toast("Api Authentication failed. login again.");
				} else if (res_data.status_code === 200) {
					setPendingSqPie({
						label: res_data.pendingCount.Label,
						data: res_data.pendingCount.Count,
					});
					setPendingGroupedSqPie({
						label: res_data.pendingGroupCount.Label,
						data: res_data.pendingGroupCount.Count,
					});
					setLastModuleWiseSQLine({
						label: res_data.completedModelWise.Label,
						data: res_data.completedModelWise.CountData,
						allData: res_data.completedModelWise.AllData,
					});
					setLastModuleOverAllSQLine({
						label: res_data.completedModelOverAll.Label,
						data: res_data.completedModelOverAll.Count,
					});
					setSummaryData({
						live_order: res_data.summaryData.live_orders,
						live_sq: res_data.summaryData.live_sq,
						coil_qty: res_data.summaryData.coil_qty,
						completed_order: res_data.summaryData.completed_orders,
						pending_orders: res_data.summaryData.pending_orders,
						last_ready: res_data.summaryData.last_ready,
						completed_work: res_data.summaryData.completed_work,
						pending_work: res_data.summaryData.pending_work,
						completed_work_cent: res_data.summaryData.completed_work_cent,
						pending_work_cent: res_data.summaryData.pending_work_cent,
						pending_man_hours: res_data.summaryData.pending_man_hours,
					});
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
	};

	const ep_material = [
		"",
		"GI 1.6mm",
		"GI 1.2mm",
		"AL 2mm",
		"AL 1.5mm",
		"SS 1.2mm",
	];
	const ep_gm_sq = [0, 6.1, 5.4, 3.5, 2.6, 6.4];


	const fin_model = ["", "3/8''", "3/8 Blue", "7mm", "1/2''"];
	const fin_hole = ["", "156", "163.2", "106.7", "336.9"];


	const pipe_type = [
		"",
		"3/8'' Plain",
		"3/8'' IG",
		"7mm IG",
		"1/2'' Plain",
		"1/2'' Thick",
	];
	const pipe_gm_m = ["", "72", "82", "57", "125", "198"];
	const pipe_model = ["", "Single", "Cross", "Straight"];


	function getGmSq(material) {
		console.log(material)
		const index = ep_material.indexOf(material);
		if (index !== -1) {
			console.log("Material:", material, "Index:", index, "Value:", ep_gm_sq[index]);
			return ep_gm_sq[index];
		} else {
			console.log("Material not found!");
			return null;
		}
	}

	const [rows, setRows] = React.useState([]);
	const [rowsfin, setRowsFin] = React.useState([]);
	const [rowsPipe, setRowsPipe] = React.useState([]);


	const [ageWeightStats, setAgeWeightStats] = React.useState({
		pipe: { grouped: [], total: 0 },
		fins: { grouped: [], total: 0 },
		endplate: { grouped: [], total: 0 },
	});



	const handleGetData = () => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		axios({
			method: "post",
			url: get_wip_ep,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 101) {
					toast("Api Authentication failed. login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data;

					if (Array.isArray(ret_data_cd) && ret_data_cd.length > 0) {
						const updatedData = ret_data_cd.map(item => {
							const gm_sq = ep_gm_sq[ep_material.indexOf(item.material)] || 0;
							const weight =
								((parseFloat(item.height) + 2) *
									(parseFloat(item.rows) + 2) *
									parseFloat(item.quantity) *
									parseFloat(gm_sq)) /
								1000;

							return {
								...item,
								gm_sq_inch: getGmSq(item.material),
								age: moment().diff(item.create_dt, "days"),
								weight: weight.toFixed(9),
							};
						});

						setRows(updatedData);
					}
					toast("Data Retrieved");
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				console.log(response);
			});
	};


	const handleGetDataFins = () => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		axios({
			method: "post",
			url: get_wip_fins,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 101) {
					toast("Api Authentication failed. login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data;

					if (Array.isArray(ret_data_cd) && ret_data_cd.length > 0) {
						const updatedData = ret_data_cd.map(item => {
							const gm_holes = fin_hole[fin_model.indexOf(item.model)] || 0;

							const calculated_value = (
								(((parseFloat(item.length) *
									parseFloat(item.height) *
									parseFloat(item.rows)) /
									1000) *
									parseFloat(gm_holes)) /
								1000
							);

							const age = moment().diff(item.create_dt, "days");

							return {
								...item,
								gm_holes,
								weight: calculated_value.toFixed(6),
								age,
							};
						});

						setRowsFin(updatedData);
					}
					toast("Data Retrieved");
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
	};


	const handleGetDataPipe = () => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		axios({
			method: "post",
			url: get_wip_pipe,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 101) {
					toast("Api Authentication failed. login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data;

					if (Array.isArray(ret_data_cd) && ret_data_cd.length > 0) {
						// Compute required fields before setting state
						const updatedData = ret_data_cd.map(item => {
							const age = moment().diff(item.create_dt, "days");

							const gm_m = pipe_gm_m[pipe_type.indexOf(item.pipe_type)] || 0;

							const weight =
								(((parseFloat(item.length) * 2 + 1.5) / 39.37) *
									parseFloat(item.quantity) *
									parseFloat(gm_m)) /
								1000;

							return {
								...item,
								age,
								gm_m,
								weight: weight.toFixed(9),
							};
						});

						setRowsPipe(updatedData);
					}
					toast("Data Retrieved");
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
	};

	React.useEffect(() => {
		let total = 0;

		const weightByAge = rows.reduce((acc, { age, weight }) => {
			const parsedWeight = parseFloat(weight) || 0;
			acc[age] = (acc[age] || 0) + parsedWeight;
			total += parsedWeight;
			return acc;
		}, {});

		const groupedData = Object.entries(weightByAge).map(([age, weight]) => ({
			age: Number(age),
			totalWeight: Number(weight.toFixed(3)),
		}));

		setAgeWeightStats(prev => ({
			...prev,
			endplate: {
				grouped: groupedData,
				total: Number(total.toFixed(3)),
			},
		}));
	}, [rows]);

	React.useEffect(() => {
		let total = 0;

		const weightByAge = rowsPipe.reduce((acc, { age, weight }) => {
			const parsedWeight = parseFloat(weight) || 0;
			acc[age] = (acc[age] || 0) + parsedWeight;
			total += parsedWeight;
			return acc;
		}, {});

		const groupedData = Object.entries(weightByAge).map(([age, weight]) => ({
			age: Number(age),
			totalWeight: Number(weight.toFixed(3)),
		}));

		setAgeWeightStats(prev => ({
			...prev,
			pipe: {
				grouped: groupedData,
				total: Number(total.toFixed(3)),
			},
		}));
	}, [rowsPipe]);

	React.useEffect(() => {
		let total = 0;

		const weightByAge = rowsfin.reduce((acc, { age, weight }) => {
			const parsedWeight = parseFloat(weight) || 0;
			acc[age] = (acc[age] || 0) + parsedWeight;
			total += parsedWeight;
			return acc;
		}, {});

		const groupedData = Object.entries(weightByAge).map(([age, weight]) => ({
			age: Number(age),
			totalWeight: Number(weight.toFixed(3)),
		}));

		setAgeWeightStats(prev => ({
			...prev,
			fins: {
				grouped: groupedData,
				total: Number(total.toFixed(3)),
			},
		}));
	}, [rowsfin]);


	useEffect(() => {
		handleGetDataFins();
	}, [])


	useEffect(() => {
		handleGetDataPipe();
	}, [])


	useEffect(() => {
		handleGetData();
	}, []);


	const [orderList, setOrderList] = useState([]);

	const [allData_excel1, setAllData_Excel] = useState([]);



	const handleOrderList = () => {

		const bodyFormData = new FormData();
		bodyFormData.append("authId", access);

		axios({
			method: "post",
			url: getOrderHistory,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				const res_data = response.data;
				if (res_data.status_code === 101) {
					toast("API Authentication failed. Login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data_orders;
					const aggregatedData = aggregateOrders(ret_data_cd);
					console.log(aggregatedData)
					setOrderList(aggregatedData);
					toast("Data Received.");
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (error) {
				console.error("Error fetching order history:", error);
			});
	};

	// const aggregateOrders = (orders) => {
	// 	// Guard against empty array
	// 	if (!orders || orders.length === 0) {
	// 		return {
	// 			dateRange: {
	// 				mostRecentDispatchDate: null,
	// 				cutoffDate: null,
	// 				mostRecentMonth: null,
	// 				mostRecentDay: null,
	// 				cutoffMonth: null,
	// 				cutoffDay: null
	// 			},
	// 			customers: []
	// 		};
	// 	}

	// 	let mostRecentDate = null;

	// 	for (const order of orders) {
	// 		if (!order.dispatch_status_dt) continue;

	// 		const dispatchDate = new Date(order.dispatch_status_dt);

	// 		if (isNaN(dispatchDate.getTime())) continue;

	// 		if (!mostRecentDate || dispatchDate > mostRecentDate) {
	// 			mostRecentDate = dispatchDate;
	// 		}
	// 	}

	// 	// If no valid dates were found
	// 	if (!mostRecentDate) {
	// 		return {
	// 			dateRange: {
	// 				mostRecentDispatchDate: null,
	// 				cutoffDate: null,
	// 				mostRecentMonth: null,
	// 				mostRecentDay: null,
	// 				cutoffMonth: null,
	// 				cutoffDay: null
	// 			},
	// 			customers: []
	// 		};
	// 	}

	// 	// Format date to get month and day names
	// 	const formatMonth = (date) => {
	// 		return date.toLocaleString('default', { month: 'long' });
	// 	};

	// 	const formatDay = (date) => {
	// 		return date.toLocaleString('default', { weekday: 'long' });
	// 	};

	// 	const mostRecentDateStr = mostRecentDate.toISOString().split('T')[0];
	// 	const mostRecentMonth = formatMonth(mostRecentDate);
	// 	const mostRecentDay = formatDay(mostRecentDate);

	// 	console.log("Most recent dispatch date:", mostRecentDateStr);

	// 	// Calculate the cutoff date (300 days before the most recent dispatch date)
	// 	const cutoffDate = new Date(mostRecentDate);
	// 	cutoffDate.setDate(cutoffDate.getDate() - 300);

	// 	const cutoffDateStr = cutoffDate.toISOString().split('T')[0];
	// 	const cutoffMonth = formatMonth(cutoffDate);
	// 	const cutoffDay = formatDay(cutoffDate);

	// 	console.log("Cutoff date (300 days prior):", cutoffDateStr);

	// 	const filteredOrders = orders.filter(order => {
	// 		if (!order.dispatch_status_dt) return false;

	// 		const dispatchDate = new Date(order.dispatch_status_dt);

	// 		// Check if the date is valid
	// 		if (isNaN(dispatchDate.getTime())) return false;

	// 		return dispatchDate >= cutoffDate;
	// 	});

	// 	console.log(`Filtered from ${orders.length} to ${filteredOrders.length} orders`);

	// 	const summary = {};

	// 	filteredOrders.forEach((order) => {
	// 		const name = order.full_customer_name?.trim() || "Unknown Customer";
	// 		const sqFeet = parseFloat(order.sq_feet) || 0;

	// 		if (summary[name]) {
	// 			summary[name] += sqFeet;
	// 		} else {
	// 			summary[name] = sqFeet;
	// 		}
	// 	});

	// 	// Create the result array and sort by sqFeet in descending order
	// 	const result = Object.entries(summary)
	// 		.map(([customerName, totalSqFeet], index) => ({
	// 			id: index + 1,
	// 			customerName,
	// 			sqFeet: totalSqFeet.toFixed(2),
	// 			sqFeetNumeric: totalSqFeet // Adding this property for accurate sorting
	// 		}))
	// 		.sort((a, b) => b.sqFeetNumeric - a.sqFeetNumeric);

	// 	// Reassign IDs based on the new sorted order
	// 	const customers = result.map((item, index) => ({
	// 		id: index + 1,
	// 		customerName: item.customerName,
	// 		sqFeet: item.sqFeet
	// 	}));

	// 	// Return both the date range information (including text representations) and the customer data
	// 	return {
	// 		dateRange: {
	// 			mostRecentDispatchDate: mostRecentDateStr,
	// 			cutoffDate: cutoffDateStr,
	// 			mostRecentMonth: mostRecentMonth,
	// 			mostRecentDay: mostRecentDay,
	// 			cutoffMonth: cutoffMonth,
	// 			cutoffDay: cutoffDay
	// 		},
	// 		customers: customers
	// 	};
	// };




	// const aggregateOrders = (orders) => {
	// 	// Guard against empty array
	// 	if (!orders || orders.length === 0) {
	// 		return {
	// 			dateRange: {
	// 				mostRecentDispatchDate: null,
	// 				cutoffDate: null,
	// 				mostRecentMonth: null,
	// 				mostRecentDay: null,
	// 				cutoffMonth: null,
	// 				cutoffDay: null
	// 			},
	// 			customers: []
	// 		};
	// 	}

	// 	let mostRecentDate = null;

	// 	for (const order of orders) {
	// 		if (!order.dispatch_status_dt) continue;

	// 		const dispatchDate = new Date(order.dispatch_status_dt);

	// 		if (isNaN(dispatchDate.getTime())) continue;

	// 		if (!mostRecentDate || dispatchDate > mostRecentDate) {
	// 			mostRecentDate = dispatchDate;
	// 		}
	// 	}

	// 	// If no valid dates were found
	// 	if (!mostRecentDate) {
	// 		return {
	// 			dateRange: {
	// 				mostRecentDispatchDate: null,
	// 				cutoffDate: null,
	// 				mostRecentMonth: null,
	// 				mostRecentDay: null,
	// 				cutoffMonth: null,
	// 				cutoffDay: null
	// 			},
	// 			customers: []
	// 		};
	// 	}

	// 	// Format date to get month and day names
	// 	const formatMonth = (date) => {
	// 		return date.toLocaleString('default', { month: 'long' });
	// 	};

	// 	const formatDay = (date) => {
	// 		return date.toLocaleString('default', { weekday: 'long' });
	// 	};

	// 	const mostRecentDateStr = mostRecentDate.toISOString().split('T')[0];
	// 	const mostRecentMonth = formatMonth(mostRecentDate);
	// 	const mostRecentDay = formatDay(mostRecentDate);

	// 	console.log("Most recent dispatch date:", mostRecentDateStr);

	// 	// Calculate the cutoff date (300 days before the most recent dispatch date)
	// 	const cutoffDate = new Date(mostRecentDate);
	// 	cutoffDate.setDate(cutoffDate.getDate() - 300);

	// 	const cutoffDateStr = cutoffDate.toISOString().split('T')[0];
	// 	const cutoffMonth = formatMonth(cutoffDate);
	// 	const cutoffDay = formatDay(cutoffDate);

	// 	console.log("Cutoff date (300 days prior):", cutoffDateStr);

	// 	const filteredOrders = orders.filter(order => {
	// 		if (!order.dispatch_status_dt) return false;

	// 		const dispatchDate = new Date(order.dispatch_status_dt);

	// 		// Check if the date is valid
	// 		if (isNaN(dispatchDate.getTime())) return false;

	// 		return dispatchDate >= cutoffDate;
	// 	});

	// 	console.log(`Filtered from ${orders.length} to ${filteredOrders.length} orders`);

	// 	const summary = {};
	// 	let totalSqFeetAll = 0; // Track total square footage across all customers

	// 	filteredOrders.forEach((order) => {
	// 		const name = order.full_customer_name?.trim() || "Unknown Customer";
	// 		const sqFeet = parseFloat(order.sq_feet) || 0;

	// 		if (summary[name]) {
	// 			summary[name] += sqFeet;
	// 		} else {
	// 			summary[name] = sqFeet;
	// 		}

	// 		totalSqFeetAll += sqFeet; // Add to the total
	// 	});

	// 	console.log(totalSqFeetAll);

	// 	// Create the result array and sort by sqFeet in descending order
	// 	const result = Object.entries(summary)
	// 		.map(([customerName, totalSqFeet], index) => ({
	// 			id: index + 1,
	// 			customerName,
	// 			sqFeet: totalSqFeet.toFixed(3),
	// 			sqFeetNumeric: totalSqFeet,
	// 			percentage: totalSqFeetAll > 0 ? ((totalSqFeet / totalSqFeetAll) * 100).toFixed(3) + "%" : "0.00" // Calculate percentage
	// 		}))
	// 		.sort((a, b) => b.sqFeetNumeric - a.sqFeetNumeric);


	// 	const customers = result.map((item, index) => ({
	// 		id: index + 1,
	// 		customerName: item.customerName,
	// 		sqFeet: item.sqFeet,
	// 		percentage: item.percentage // Include the percentage in the final output
	// 	}));

	// 	// Return both the date range information (including text representations) and the customer data
	// 	return {
	// 		dateRange: {
	// 			mostRecentDispatchDate: mostRecentDateStr,
	// 			cutoffDate: cutoffDateStr,
	// 			mostRecentMonth: mostRecentMonth,
	// 			mostRecentDay: mostRecentDay,
	// 			cutoffMonth: cutoffMonth,
	// 			cutoffDay: cutoffDay
	// 		},
	// 		customers: customers,
	// 		totalSqFeet: totalSqFeetAll.toFixed(2) // Optionally include the total in the result
	// 	};
	// };




	const handleDownloadExcelData = () => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		bodyFormData.append("reqType", "history");

		axios({
			method: "post",
			url: allData_excel,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then((response) => {
				const res_data = response.data;
				if (res_data.status_code === 101) {
					toast("API Authentication failed. Login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data;
					console.log(ret_data_cd, "data")
					const aggregatedData = aggregateOrders(ret_data_cd);
					console.log(aggregatedData)
					setAllData_Excel(aggregatedData);
					toast("Data Received.");
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch((error) => {
				console.error("Error downloading Excel file:", error);
				toast("Failed to download Excel data.");
			});
	};




	useEffect(() => {
		handleDownloadExcelData();
		// handleOrderList();
	}, []);


	const renderPendingSQPie = () => {
		return <PendingSqPie
			label={pendingSqPie.label}
			data={pendingSqPie.data} />;
	};



	const renderPendingGroupedSQPie = () => {
		return (
			<PendingGroupedSqPie
				label={pendingGroupedSqPie.label}
				data={pendingGroupedSqPie.data}
			/>
		);
	};

	const renderLastModuleWiseSQLine = () => {
		return (
			<LastModuleWiseLine
				label={lastModuleWiseSQLine.label}
				data={lastModuleWiseSQLine.data}
			/>
		);
	};



	const renderLastModuleOverAllSQLine = () => {
		return (
			<LastModuleOverAllLine
				label={lastModuleOverAllSQLine.label}
				data={lastModuleOverAllSQLine.data}
			/>
		);
	};

	//module performance table
	const columns = [
		{
			field: "ol_date",
			headerName: "Order Date",
			flex: 1,
		},
		{
			field: "cnc_nest_compsq",
			headerName: "CNC Nest",
			flex: 1,
		},
		{
			field: "cnc_punch_compsq",
			headerName: "CNC Punch",
			flex: 1,
		},
		{
			field: "bending_compsq",
			headerName: "Bending",

			flex: 1,
		},
		{
			field: "tcutting_compsq",
			headerName: "Tube Cutting",
			flex: 1,
		},
		{
			field: "finpunch_compsq",
			headerName: "Fin Punch",
			flex: 1,
		},
		{
			field: "ca_compsq",
			headerName: "Coil Assembly",
			flex: 1,
		},
		{
			field: "ce_compsq",
			headerName: "Coil Expansion",
			flex: 1,
		},
		{
			field: "brazing_compsq",
			headerName: "Brazing",
			flex: 1,
		},
		{
			field: "pp_compsq",
			headerName: "Paint & Packing",
			flex: 1,
		},
		// {
		// 	field: "dispatch_compsq",
		// 	headerName: "Dispatch",
		// 	flex: 1,
		// },
		{
			field: "CustomField",
			headerName: "Total",
			renderCell: (params) => {
				return rowTotal(params?.row);
			},
			flex: 1,
		},
		// {
		// 	field: "CustomField2",
		// 	headerName: "Average",
		// 	valueGetter: (params) => {
		// 		return rowTotalAverage(params.row);
		// 	},
		// 	flex: 1,
		// },
	];

	React.useEffect(function () {
		handlePendingSqCount(access);
	}, []);

	React.useEffect(
		function () {
			if (pendingSqPie.data?.length > 0) {
				setCompPendingSQCountGraph(renderPendingSQPie());
			}
			if (pendingGroupedSqPie.data?.length > 0) {
				setCompPendingGroupedSQCountGraph(renderPendingGroupedSQPie());
			}
			if (lastModuleWiseSQLine.label?.length > 0) {
				setCompLastModuleLineSQCountGraph(renderLastModuleWiseSQLine());
			}
			if (lastModuleOverAllSQLine.data?.length > 0) {
				setCompLastModuleOverAllLineSQCountGraph(
					renderLastModuleOverAllSQLine()
				);
			}
		},
		[
			pendingSqPie.data,
			pendingGroupedSqPie.data,
			lastModuleWiseSQLine.label,
			lastModuleOverAllSQLine.data,
		]
	);




	// function aggregateOrders(data) {
	// 	console.log(data)
	// 	if (!data || data.length === 0) {
	// 		return [];
	// 	}

	// 	let mostRecentDate = null;



	// 	for (const order of data) {
	// 		if (!order.order_date) continue;

	// 		console.log(order.order_date)

	// 		const [day, month, year] = order.order_date.split('/');
	// 		const orderDate = new Date(`${year}-${month}-${day}`);

	// 		console.log(orderDate)

	// 		if (isNaN(orderDate.getTime())) continue;

	// 		if (!mostRecentDate || orderDate > mostRecentDate) {
	// 			mostRecentDate = orderDate;
	// 		}
	// 	}

	// 	if (!mostRecentDate) {
	// 		console.log("No valid order dates found");
	// 		return [];
	// 	}
	// 	console.log(mostRecentDate)
	// 	const cutoffDate = new Date(mostRecentDate);
	// 	cutoffDate.setDate(cutoffDate.getDate() - 350);

	// 	console.log("Most recent order date:", mostRecentDate);
	// 	console.log("Cutoff date (350 days prior):", cutoffDate);

	// 	const filteredData = data.filter(order => {
	// 		if (!order.order_date) return false;

	// 		const [day, month, year] = order.order_date.split('/');
	// 		const orderDate = new Date(`${year}-${month}-${day}`);

	// 		if (isNaN(orderDate.getTime())) return false;

	// 		return orderDate >= cutoffDate;
	// 	});

	// 	console.log(`filteredData`, filteredData);

	// 	const result = {};
	// 	let idCounter = 1;

	// 	const monthNames = [
	// 		"Jan", "Feb", "Mar", "Apr", "May", "Jun",
	// 		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	// 	];

	// 	Object.values(result).forEach(customer => {
	// 		console.log(
	// 			customer.customerName,
	// 			"=>",
	// 			customer.totalSqFeet
	// 		);
	// 	});

	// 	filteredData.forEach(order => {
	// 		const customer = order.full_customer_name;
	// 		const [day, month, year] = order.order_date.split('/');
	// 		const orderDate = new Date(`${year}-${month}-${day}`);
	// 		if (isNaN(orderDate)) return;

	// 		const monthIndex = Number(month);
	// 		console.log(monthIndex);
	// 		const monthName = monthNames[monthIndex - 1];
	// 		const sqFeet = parseFloat(order.sq_feet) || 0;



	// 		if (!result[customer]) {
	// 			result[customer] = {
	// 				id: idCounter++,
	// 				customerName: customer,
	// 				totalSqFeet: 0,
	// 			};
	// 			monthNames.forEach(m => {
	// 				result[customer][m] = 0;
	// 			});
	// 		}

	// 		result[customer][monthName] += sqFeet;
	// 		result[customer].totalSqFeet += sqFeet;
	// 	});

	// 	console.log(result);
	// 	return Object.values(result).sort((a, b) => b.totalSqFeet - a.totalSqFeet);
	// }


	function aggregateOrders(data) {
		if (!data || data.length === 0) return [];

		let mostRecentDate = null;

		// Find most recent order date
		for (const order of data) {
			if (!order.dispatch_status_dt) continue;
			if (!order.dispatch_status_dt) continue;           // empty, null, undefined
			if (order.dispatch_status_dt.startsWith("0000")) continue;

			const [year, month, day] = order.dispatch_status_dt.split('-');
			const orderDate = new Date(`${year}-${month}-${day}`);
			console.log(orderDate);
			if (isNaN(orderDate.getTime())) continue;

			if (!mostRecentDate || Number(orderDate) > mostRecentDate) {
				mostRecentDate = orderDate;
			}
		}
		console.log(mostRecentDate);

		if (!mostRecentDate) return [];

		// 350-day cutoff
		const cutoff350 = new Date(mostRecentDate);
		cutoff350.setDate(cutoff350.getDate() - 365);

		const mostRecentYear = mostRecentDate.getFullYear();
		const mostRecentMonth = mostRecentDate.getMonth(); // 0-indexed

		console.log("Most recent:", mostRecentDate);
		console.log("365-day cutoff:", cutoff350);

		// Filter orders
		const filteredData = data.filter(order => {
			if (!order.order_date) return false;

			const [year, month, day] = order.dispatch_status_dt.split('-');
			const orderDate = new Date(`${year}-${month}-${day}`);
			if (isNaN(orderDate.getTime())) return false;

			// Must be inside 365-day window
			if (orderDate < cutoff350) return false;

			const orderYear = orderDate.getFullYear();

			// 🚫 If current month HAS started, do not include previous year
			if (
				orderYear < mostRecentYear &&
				orderDate.getMonth() <= mostRecentMonth
			) {
				return false;
			}

			return true;
		});



		// Aggregate
		const result = {};
		let idCounter = 1;

		const monthNames = [
			"Jan", "Feb", "Mar", "Apr", "May", "Jun",
			"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
		];

		filteredData.forEach(order => {
			const customer = order.full_customer_name;
			const [year, month, day] = order.dispatch_status_dt.split('-');
			const orderDate = new Date(`${year}-${month}-${day}`);
			if (isNaN(orderDate)) return;

			const monthIndex = Number(month);
			const monthName = monthNames[monthIndex - 1];
			const sqFeet = parseFloat(order.sq_feet) || 0;

			if (!result[customer]) {
				result[customer] = {
					id: idCounter++,
					customerName: customer,
					totalSqFeet: 0,
				};
				monthNames.forEach(m => result[customer][m] = 0);
			}

			result[customer][monthName] += sqFeet;
			result[customer].totalSqFeet += sqFeet;
		});

		return Object.values(result).sort((a, b) => b.totalSqFeet - a.totalSqFeet);
	}


	const currentMonthIndex = new Date().getMonth();

	const monthNames = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];

	const rotatedMonths = [
		...monthNames.slice(currentMonthIndex + 1), // Months after current month (Jul, Aug, Sep, Oct, Nov, Dec)
		...monthNames.slice(0, currentMonthIndex),
		monthNames[currentMonthIndex]
	];

	// Create columns for each month using month names as field keys
	const monthlyColumns = rotatedMonths.map((month) => ({
		field: month,
		headerName: month,
		flex: 1,
		headerAlign: "center",
		align: "center",
		type: "number",
	}));


	const columns1 = [
		{
			field: "customerName",
			headerName: "Customer Name",
			flex: 1,
			headerAlign: "center",
			align: "center",
			minWidth: 300,
		},
		...monthlyColumns,
		{
			field: "totalSqFeet",
			headerName: "Total Sq. Feet",
			flex: 1,
			headerAlign: "center",
			align: "center",
			type: "number",
		}
	];


	return (
		<div className="container" style={{ marginTop: "105px", width: "100%" }}>
			<div className="row">
				<div className="col-lg-4  col-md-6 mt-3 ">
					<div className="card col-sm p-1" style={{ height: "100%" }}>
						<h4 className="text-center ">Module Status</h4>
						<div  >
							{compPendingSQCountGraph}
						</div>

					</div>
				</div>
				<div className="col-lg-4 col-md-6 mt-3 ">
					<div className="card " style={{ height: "100%" }}>
						<h4 className="text-center">Summary</h4>
						<div>
							<table className="table table-bordered table-striped">
								<tbody>
									<tr>
										<td>Orders</td>
										<td>{summaryData.live_order}</td>
									</tr>
									<tr>
										<td>Sq.ft.</td>
										<td>{summaryData.live_sq}</td>
									</tr>
									<tr>
										<td>Coils</td>
										<td>{summaryData.coil_qty}</td>
									</tr>
									<tr>
										<td>Completed orders</td>
										<td>{summaryData.completed_order}</td>
									</tr>
									<tr>
										<td>Pending orders</td>
										<td>{summaryData.pending_orders}</td>
									</tr>
									<tr>
										<td>Last Ready date</td>
										<td>{summaryData.last_ready}</td>
									</tr>
									<tr>
										<td>Completed work</td>
										<td>{summaryData.completed_work}</td>
									</tr>
									<tr>
										<td>Completed work %</td>
										<td>{summaryData.completed_work_cent} %</td>
									</tr>
									<tr>
										<td>Pending work</td>
										<td>{summaryData.pending_work}</td>
									</tr>
									<tr>
										<td>Pending work %</td>
										<td>{summaryData.pending_work_cent} %</td>
									</tr>
									<tr>
										<td>Pending as per man hours</td>
										<td>
											{(
												summaryData.pending_man_hours /
												(colTotal(
													lastModuleWiseSQLine.allData,
													"cnc_nest_compsq"
												) +
													colTotal(
														lastModuleWiseSQLine.allData,
														"cnc_punch_compsq"
													) +
													colTotal(
														lastModuleWiseSQLine.allData,
														"bending_compsq"
													) +
													colTotal(
														lastModuleWiseSQLine.allData,
														"tcutting_compsq"
													) +
													colTotal(
														lastModuleWiseSQLine.allData,
														"finpunch_compsq"
													) +
													colTotal(lastModuleWiseSQLine.allData, "ca_compsq") +
													colTotal(lastModuleWiseSQLine.allData, "ce_compsq") +
													colTotal(
														lastModuleWiseSQLine.allData,
														"brazing_compsq"
													) +
													colTotal(lastModuleWiseSQLine.allData, "pp_compsq"))
											).toFixed(2)}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div className="col-lg-4 col-md-6  mt-3  mx-auto ">
					<div className="card col-sm p-1" style={{ height: "100%" }}>
						<h4 className="text-center ">Section Status</h4>
						{compPendingGroupedSQCountGraph}
					</div>
				</div>
			</div>

			<div className="row mt-3">
				<div>
					<div className="card col-sm p-1">
						<h4 className="text-center">Module Performance</h4>
						<div className="scroll">
							{compLastModuleLineSQCountGraph}
						</div>
					</div>
				</div>
			</div>




			{/* <div>
				<div>
					<h4 className="text-center">Fins Age and Weight</h4>
					<div className="scroll">
						<AgeWeightBarChart data={ageWeightStats} />
					</div>
				</div>
			</div>

			<div>
				<div>
					<h4 className="text-center">Pipe Age and Weight</h4>
					<div className="scroll">
						<AgeWeightBarChart data={ageWeightStats} />
					</div>
				</div>
			</div> */}


			<div className="row mt-3">
				<div>
					<div className="card col-sm p-1">
						<h4 className="text-center">Over All Performance</h4>

						<div className="scroll   ">
							{compLastModuleOverAllLineSQCountGraph}
						</div>

					</div>
				</div>
			</div>

			<div className="row  mt-2">
				<div className="p-2">
					<div>
						<div style={{ maxHeight: '400px', overflowY: 'scroll' }}>
							<table className="table table-striped table-bordered">
								<tbody>
									<tr>
										<th>Average</th>
										<td>
											{colTotal(lastModuleWiseSQLine.allData, "cnc_nest_compsq")}
										</td>
										<td>
											{colTotal(lastModuleWiseSQLine.allData, "cnc_punch_compsq")}
										</td>
										<td>
											{colTotal(lastModuleWiseSQLine.allData, "bending_compsq")}
										</td>
										<td>
											{colTotal(lastModuleWiseSQLine.allData, "tcutting_compsq")}
										</td>
										<td>
											{colTotal(lastModuleWiseSQLine.allData, "finpunch_compsq")}
										</td>
										<td>{colTotal(lastModuleWiseSQLine.allData, "ca_compsq")}</td>
										<td>{colTotal(lastModuleWiseSQLine.allData, "ce_compsq")}</td>
										<td>
											{colTotal(lastModuleWiseSQLine.allData, "brazing_compsq")}
										</td>
										<td>{colTotal(lastModuleWiseSQLine.allData, "pp_compsq")}</td>
										<td>
											{colTotal(lastModuleWiseSQLine.allData, "cnc_nest_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "cnc_punch_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "bending_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "tcutting_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "finpunch_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "ca_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "ce_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "brazing_compsq") +
												colTotal(lastModuleWiseSQLine.allData, "pp_compsq")}
										</td>
									</tr>
								</tbody>
							</table>
						</div>



						<DataGrid
							slots={{ toolbar: GridToolbar }}
							getRowId={(row) => Math.random()}
							getRowClassName={(params) => {
								if (params.indexRelativeToCurrentPage % 2 === 0) {
									if (params.row?.priority === "true") {
										return "secon-bg";
									} else if (
										params.row?.tcutting_status === "true" &&
										params.row?.finpunch_status === "true"
									) {
										return "partial-comp-bg";
									} else {
										return "Mui-even";
									}
								} else {
									if (params.row?.priority === "true") {
										return "secon-bg";
									} else if (
										params.row?.tcutting_status === "true" &&
										params.row?.finpunch_status === "true"
									) {
										return "partial-comp-bg";
									} else {
										return "Mui-odd";
									}
								}
							}}
							sx={{
								"& .MuiDataGrid-columnHeader": {
									backgroundColor: "#943612",
									color: "white",
								},
								".MuiDataGrid-row.Mui-odd ": {
									backgroundColor: "#FFE1D6",
								},
								".MuiDataGrid-row.Mui-even ": {
									backgroundColor: "#F2F2F2",
								},
								".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell":
								{
									overflow: "visible !important",
									whiteSpace: "break-spaces",
									padding: 0,
									display: "flex",
									justifyContent: "center",
									fontSize: "0.75rem",
								},
								".MuiDataGrid-columnHeaderTitleContainer": {
									display: "flex",
									justifyContent: "center",
									fontSize: "0.75rem",
								},
								"& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
									border: ".5px solid white",
								},
								"& .MuiInputBase-input": {
									fontSize: "0.74rem",
									padding: "16.5px 1px ",
								},
							}}
							rowHeight={50}
							columns={columns}
							rows={lastModuleWiseSQLine.allData}
							editMode="row"
						/>
					</div>
				</div>
			</div>



			<DataGrid
				slots={{ toolbar: GridToolbar }}
				rows={allData_excel1}
				columns={columns1}
				// columns={columns1.map((column) => ({
				// 	...column,
				// 	...(column.field === 'customer Name'
				// 		? { width: 120 } // Set a visible width
				// 		: {}),           // Optional: add default widths or styles to other columns here
				// }))}
				initialState={{
					pagination: {
						paginationModel: { page: 0, pageSize: 10 },
					},
				}}
				pageSizeOptions={[10, 25, 50]}
				getRowClassName={(params) => {
					const isEven = params.indexRelativeToCurrentPage % 2 === 0;
					const baseClass = isEven ? "Mui-even" : "Mui-odd";

					return baseClass

				}}
				sx={{
					"& .MuiDataGrid-root": {
						width: "100% !important",
					},
					"& .MuiDataGrid-columnHeader": {
						backgroundColor: "#943612",
						color: "white",
					},
					".MuiDataGrid-row.Mui-odd": {
						backgroundColor: "#FFE1D6",
					},
					".MuiDataGrid-row.Mui-even": {
						backgroundColor: "#F2F2F2",
					},
					".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell": {
						whiteSpace: "break-spaces",
						padding: 0,
						display: "flex",
						justifyContent: "center",
						fontSize: "0.75rem",
					},
					".MuiDataGrid-columnHeaderTitleContainer": {
						display: "flex",
						justifyContent: "center",
						fontSize: "0.75rem",
					},
					"& .MuiDataGrid-cell.MuiDataGrid-cell ": {
						border: ".5px solid white !important",
					},
					"& .MuiInputBase-input": {
						fontSize: "0.74rem",
						padding: "16.5px 1px",
					},
				}}
			/>


			<div>
				<div>
					<h4 className="text-center">WIP Stock</h4>
					<div className="scroll">
						{/* <AgeWeightBarChart data={ageWeightStats} /> */}

						<AgeWeightDashboard data={ageWeightStats} />
					</div>
				</div>
			</div>

		</div>


	);
}
